/* Landing txcream — JS extraído de la fuente.
   Lo carga layout/landing.liquid (case 'txcream'). */


(function(){
  var fmt = function(n){ return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); };
  var names = {1:'1 frasco · Para empezar', 2:'2 frascos · Ritual completo', 3:'3 frascos · 3 por menos que 2'};
  var combos = document.querySelectorAll('#comprar .bundle');
  var finalPrice = document.getElementById('finalPrice');
  var finalName = document.getElementById('finalName');
  var stickyPrice = document.getElementById('stickyPrice');

  function select(el){
    combos.forEach(function(b){ b.classList.remove('on'); b.setAttribute('aria-checked','false'); });
    el.classList.add('on'); el.setAttribute('aria-checked','true');
    var p = fmt(el.dataset.price);
    finalPrice.textContent = p; stickyPrice.textContent = p; finalName.textContent = names[el.dataset.qty];
  }
  // los combos SOLO seleccionan (regla 20-oct); el formulario de Releasit lo abre el botón de compra
  // y llega con la cantidad del combo elegido (window.__txcream_SEL -> input[name=quantity])
  combos.forEach(function(b){
    b.addEventListener('click', function(e){ e.preventDefault(); select(b); });
    b.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(b); } });
  });

  // galería
  var main = document.getElementById('galMain');
  var ths = [].slice.call(document.querySelectorAll('.thumbs .th'));
  var gm = document.querySelector('.gal-main');
  var dots = document.createElement('div'); dots.className = 'dots';
  ths.forEach(function(){ dots.appendChild(document.createElement('i')); }); gm.appendChild(dots);
  var cur = 0;
  function show(i){
    cur = (i + ths.length) % ths.length;
    ths.forEach(function(x, k){ x.classList.toggle('on', k === cur); dots.children[k].classList.toggle('on', k === cur); });
    main.src = ths[cur].dataset.src;
    main.classList.remove('swap'); void main.offsetWidth; main.classList.add('swap');
  }
  ths.forEach(function(t, k){
    function go(e){ e.preventDefault(); e.stopPropagation(); show(k); }
    t.addEventListener('click', go);
    t.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') go(e); });
  });
  var sx = 0, sy = 0;
  gm.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
  gm.addEventListener('touchend', function(e){
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(cur + (dx < 0 ? 1 : -1));
  }, { passive: true });
  show(0);

  // ===== punto de compra único (contrato Shopify, slug txcream) =====
  function abrirModalLocal(qty, total){
    document.getElementById('maskTxt').textContent = qty + ' × Dr. Melaxin TX-Cream — total ' + fmt(total) + ' (pago contra entrega).';
    document.getElementById('maskWa').href = 'https://wa.me/573505802167?text=' + encodeURIComponent('Hola, quiero ' + qty + ' TX-Cream (' + fmt(total) + ')');
    document.getElementById('mask').classList.add('on');
  }
  // Releasit trae su propio selector de cantidad en el modal (radios quantity_offer): preseleccionar el combo elegido en la página.
  // Se verifica cada 50 ms (radio + Total del combo) y, mientras se ajusta, se avisa y se bloquea SOLO el botón de enviar (la X sigue activa).
  function busy(d, on){
    d.querySelectorAll('.rsi-custom-button, button[type="submit"]').forEach(function(b){ b.style.pointerEvents = on ? 'none' : ''; });
    var b = d.querySelector('.tx-busy');
    if (on && !b) {
      b = document.createElement('div'); b.className = 'tx-busy'; b.textContent = 'Ajustando tu pedido…';
      b.style.cssText = 'position:fixed;left:50%;top:14px;transform:translateX(-50%);background:#0E2A47;color:#fff;font:700 14px Inter,Arial,sans-serif;padding:8px 18px;border-radius:99px;z-index:9999;box-shadow:0 4px 14px rgba(0,0,0,.3);pointer-events:none';
      d.appendChild(b);
    } else if (!on && b) { b.remove(); }
  }
  function pickOffer(qty){
    var want = 'quantity_' + (qty - 1), t0 = Date.now(), ok = 0, on = false, dlg = null;
    var cb = document.querySelector('#comprar .bundle[data-qty="' + qty + '"]');
    var price = cb ? fmt(cb.dataset.price).replace('$', '') : '';
    (function tick(){
      var d = document.querySelector('dialog[open]');
      var r = d && d.querySelector('input[name="quantity_offer"][value="' + want + '"]');
      if (r) {
        dlg = d;
        if (!on) { on = true; busy(d, true); }
        if (!r.checked) { r.click(); ok = 0; }
        else {
          var m = d.innerText.match(/Total\s*\$([\d.]+)/);
          if (!price || (m && m[1] === price)) ok++; else ok = 0;
        }
        if (ok >= 6) { busy(d, false); return; }
      }
      if (Date.now() - t0 > 20000) { if (dlg) busy(dlg, false); return; }
      setTimeout(tick, 50);
    })();
  }
  // respuesta inmediata al tocar un botón de compra: spinner hasta que el formulario abre (o 8 s)
  function markOpening(el){
    if (!el) return; el.classList.add('opening');
    var t0 = Date.now(), iv = setInterval(function(){
      var d = document.querySelectorAll('dialog'), open = false;
      for (var k = 0; k < d.length; k++) { if (d[k].open && /rsi/.test(String(d[k].className))) open = true; }
      if (open) { clearInterval(iv); el.classList.remove('opening'); return; }
      if (Date.now() - t0 > 8000) {
        // red de seguridad: si Releasit no abrió en 8 s, el cliente no se queda con un botón muerto (cae al pedido por WhatsApp)
        clearInterval(iv); el.classList.remove('opening');
        var cb = document.querySelector('#comprar .bundle.on');
        abrirModalLocal(cb ? +cb.dataset.qty : 2, cb ? +cb.dataset.price : 124900);
      }
    }, 100);
  }
  function openOrder(){
    var on = document.querySelector('#comprar .bundle.on');
    var qty = on ? +on.dataset.qty : 2;
    var total = on ? +on.dataset.price : 124900;
    window.__txcream_SEL = { qty: qty };
    try { localStorage.setItem('te_regalo', (qty === 1 ? 'txcream-1' : 'txcream') + '|' + Date.now()); } catch (e) {}
    if (window.txcreamTriggerCOD && window.txcreamTriggerCOD() !== false) { pickOffer(qty); return; }
    abrirModalLocal(qty, total);
  }
  ['cta-hero','cta-mid','cta-tst','cta-final','cta-sticky'].forEach(function(id){
    var el = document.getElementById(id);
    if (el) el.addEventListener('click', function(){ markOpening(el); openOrder(); });
  });
  document.getElementById('maskClose').addEventListener('click', function(){ document.getElementById('mask').classList.remove('on'); });

  // ===== pop-up de pedidos reales =====
  // SOLO pedidos verificados en Shopify (sin pruebas, spam ni cancelados). Nombre de pila + ciudad.
  // Mantener esta lista al día: agregar los pedidos nuevos y quitar los cancelados. Más reciente primero.
  var ORDERS = [
    { n: 'Alberto', c: 'Bogotá', q: 2, t: '2026-10-22T01:50:17Z' },
    { n: 'Amparo', c: 'Ibagué', q: 1, t: '2026-10-21T10:44:55Z' },
    { n: 'Edirley', c: 'Pereira', q: 2, t: '2026-10-21T03:39:33Z' },
    { n: 'Rosa', c: 'Piedecuesta', q: 2, t: '2026-10-18T16:40:22Z' },
    { n: 'Margarita', c: 'Envigado', q: 2, t: '2026-10-18T14:08:53Z' },
    { n: 'Cecilia', c: 'Bogotá', q: 1, t: '2026-10-17T01:46:33Z' },
    { n: 'Blanca', c: 'Bogotá', q: 1, t: '2026-10-16T11:45:33Z' }
  ];
  function ago(iso){
    var m = Math.max(1, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
    if (m < 60) return 'hace ' + m + ' min';
    var h = Math.round(m / 60); if (h < 24) return 'hace ' + h + (h === 1 ? ' hora' : ' horas');
    var d = Math.round(h / 24); return 'hace ' + d + (d === 1 ? ' día' : ' días');
  }
  (function(){
    var pop = document.getElementById('pop'); if (!pop || !ORDERS.length) return;
    var i = 0, shown = 0, closed = false;
    try { if (sessionStorage.getItem('txpop_x')) closed = true; } catch (e) {}
    document.getElementById('popX').addEventListener('click', function(){
      closed = true; pop.classList.remove('on'); setTimeout(function(){ pop.hidden = true; }, 400);
      try { sessionStorage.setItem('txpop_x', '1'); } catch (e) {}
    });
    function busy(){
      if (document.getElementById('mask') && document.getElementById('mask').classList.contains('on')) return true;
      var d = document.querySelectorAll('dialog');
      for (var k = 0; k < d.length; k++) { if (d[k].open) return true; }
      return false;
    }
    function next(ms){ setTimeout(show, ms); }
    function show(){
      if (closed || shown >= 6) return;
      if (busy()) { next(4000); return; }
      var o = ORDERS[i % ORDERS.length]; i++; shown++;
      document.getElementById('popN').textContent = o.n + ' de ' + o.c;
      document.getElementById('popM').textContent = 'pidió ' + o.q + (o.q === 1 ? ' frasco' : ' frascos');
      document.getElementById('popT').textContent = ago(o.t);
      pop.hidden = false; requestAnimationFrame(function(){ requestAnimationFrame(function(){ pop.classList.add('on'); }); });
      setTimeout(function(){ pop.classList.remove('on'); setTimeout(function(){ pop.hidden = true; }, 400); next(16000); }, 6000);
    }
    next(10000);
  })();

  // sticky: visible tras pasar el hero y oculto cerca del cierre
  var sticky = document.getElementById('sticky');
  var hero = document.getElementById('comprar');
  var finalBtn = document.getElementById('cta-final');
  function tog(){
    var hb = hero.getBoundingClientRect().bottom;
    var ft = finalBtn.getBoundingClientRect().top;
    sticky.classList.toggle('show', hb < 0 && ft > window.innerHeight);
  }
  window.addEventListener('scroll', tog, { passive: true });
  tog();

  // videos de clientas: autoplay silencioso; se pausan fuera de pantalla para ahorrar datos
  var vids = [].slice.call(document.querySelectorAll('.vids video'));
  vids.forEach(function(v){ v.muted = true; v.setAttribute('muted', ''); var pr = v.play(); if (pr && pr.catch) pr.catch(function(){}); });
  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function(es){ es.forEach(function(e){
      var v = e.target; if (e.isIntersecting) { var q = v.play(); if (q && q.catch) q.catch(function(){}); } else { v.pause(); } }); }, { threshold: .25 });
    vids.forEach(function(v){ vio.observe(v); });
  }

  // contador animado (35.000 ppm, etc.)
  function countUp(root){
    root.querySelectorAll('.cnt').forEach(function(el){
      if (el.dataset.done) return; el.dataset.done = 1;
      if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var to = +el.dataset.to, t0 = null, dur = 1600;
      function step(t){ if (!t0) t0 = t; var k = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - k, 3);
        el.textContent = String(Math.round(to * e)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); if (k < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    });
  }

  // reveal
  var revs = document.querySelectorAll('.rev');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting && !e.target.classList.contains('vis')) { e.target.classList.add('vis'); countUp(e.target); } }); }, { threshold: .08 });
    revs.forEach(function(r){ io.observe(r); });
  } else { revs.forEach(function(r){ r.classList.add('vis'); }); }
})();

/* ============================================================
   Releasit COD — variante activa + cantidad + disparo del modal
   Lo genera tools/apply_cod_trigger.py desde tools/cod_trigger.js.tpl.

   PATRÓN:
   NO se crean variantes-bundle. Dropi solo despacha las variantes que
   mapeó al IMPORTAR el producto; una variante creada después por API
   queda huérfana y el pedido no le llega (bug real de producción).
   Por eso el bundle es la MISMA variante de Dropi con quantity = N, y el
   total lo baja un descuento automático de Shopify (mín. N unidades).
   Así el pedido lleva las unidades físicas reales y Dropi las despacha.

   Releasit lee la cantidad de input[name="quantity"] en el DOM al abrir,
   y la variante de window.productData — pero SOLO la re-lee si se hace
   click en su botón nativo. _rsiV2.setState abre el modal con la variante
   cacheada al init, así que queda como último recurso.
   Depende de quantityControlsHidden:true en Releasit (ya global): si el
   cliente pudiera bajar la cantidad, pagaría el precio con descuento por
   menos unidades.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
      i.setAttribute('value', variantId);
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe. */
  function qtyOf(s) {
    var q = parseInt(s && s.qty, 10);
    if (!q) { var on = document.querySelector('[data-qty].on, [data-qty].active, [data-qty][aria-checked="true"]');
      q = on ? parseInt(on.getAttribute('data-qty'), 10) : 1; }
    return q || 1;
  }
  function current() {
    var s = window.__txcream_SEL || {};
    var V = window.TXCREAM_VARIANTS || [];
    var v = V.filter(function (x) { return x.available; })[0] || V[0];
    return v ? { id: v.id, qty: qtyOf(s) } : null;
  }

  function sync() {
    var s = current();
    if (s && s.id) setVariantOnAllForms(s.id, s.qty);
    return s;
  }

  // el JS de la landing ya mueve la clase activa; aquí solo re-leemos después
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.__txcream-no-watch')) {
      setTimeout(sync, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  /* ¿Está abierto el modal de Releasit? (<dialog class="rsi-form-wrap"> con open) */
  function rsiOpen() {
    var d = document.querySelectorAll('dialog');
    for (var i = 0; i < d.length; i++) { if (d[i].open && /rsi/.test(String(d[i].className))) return true; }
    return false;
  }

  /* UN solo click debe abrir el formulario. Si el cliente toca antes de que Releasit termine de
     cargar (botón aún sin enganchar), el primer click se perdía y hacían falta dos: ahora se
     reintenta hasta confirmar que el modal abrió (máx. ~15 s). */
  window.txcreamTriggerCOD = function () {
    var s = sync();
    if (!s || !s.id) return;
    if (window.txcream_opening) clearInterval(window.txcream_opening);
    var tries = 0;
    function attempt() {
      sync();
      var b = findReleasitButton();
      if (b) b.click();
      else if (tries > 8 && window._rsiV2 && typeof window._rsiV2.setState === 'function') {
        try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
      }
    }
    setTimeout(function () {
      attempt();
      window.txcream_opening = setInterval(function () {
        tries++;
        if (rsiOpen() || tries > 50) { clearInterval(window.txcream_opening); return; }
        attempt();
      }, 300);
    }, 50);
  };
})();
